export default "__VITE_ASSET__UX4WtoLe__"